export default {"src":"/_next/static/media/calendar-gradient.b047cdef.svg","height":40,"width":40};